export default __webpack_public_path__ + "static/media/video-press-kit.36ebfeac.png";